import { getCoreRowModel, getSortedRowModel, SortingState, useReactTable } from '@tanstack/react-table'
import React, { useState } from 'react'
import TanStackTable from '../../../../../components/tables/TanStackTable'
import purchaseReportDetailsData from './purchaseReportDetailsData'
import { columnSum, formatCurrency } from '../../../../../utils/tableFuncs'

type PurchaseReportDetailsTableProps = {
  data: any
  isLoading?: boolean
  options: { year: string; month: string }
}
function PurchaseReportDetailsTable({ data, isLoading, options }: PurchaseReportDetailsTableProps) {
  const [sorting, setSorting] = useState<SortingState>([])
  const columns = purchaseReportDetailsData({ options })

  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  })

  const footerData = {
    amountincVAT: isNaN(columnSum(data, 'amountincVAT'))
      ? formatCurrency(0)
      : formatCurrency(columnSum(data, 'amountincVAT')),
  }

  return <TanStackTable table={table} isLoading={isLoading} footerData={footerData} />
}

export default PurchaseReportDetailsTable
